"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GridCell = exports.Grid = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Grid.css");

var _styles = {
  "grid": "Grid__grid___ASnO2",
  "columns-2": "Grid__columns-2___1l_uW",
  "columns-3": "Grid__columns-3___2kmAh",
  "columns-4": "Grid__columns-4___qMaQv",
  "columns-8": "Grid__columns-8___2xH6P",
  "columns-12": "Grid__columns-12___quiio",
  "columns-min-content": "Grid__columns-min-content___F3DPX",
  "grid-cell": "Grid__grid-cell___1OB4z",
  "span-1-columns": "Grid__span-1-columns___yPF1r",
  "span-2-columns": "Grid__span-2-columns___2KIZm",
  "span-3-columns": "Grid__span-3-columns___1Z5rw",
  "span-4-columns": "Grid__span-4-columns___1qrwe",
  "span-5-columns": "Grid__span-5-columns___3HbDT",
  "span-6-columns": "Grid__span-6-columns___1dKLx",
  "span-7-columns": "Grid__span-7-columns___3b1NB",
  "span-8-columns": "Grid__span-8-columns___dGsEp",
  "span-9-columns": "Grid__span-9-columns___2CBf-",
  "span-10-columns": "Grid__span-10-columns___2ENJF",
  "span-11-columns": "Grid__span-11-columns___2RY1x",
  "span-12-columns": "Grid__span-12-columns___1gori"
};

const styles = _bind.default.bind(_styles);

const formatToCSS = value => {
  return Array.isArray(value) ? value.map(val => `${val}px`).join(' ') : `${value}px`;
};

const GridCell = (0, _mobxReact.observer)(({
  children,
  className,
  dataTestId,
  columns = 1,
  rows,
  padding,
  alignSelf,
  justifySelf,
  style
}) => {
  const composedClassname = (0, _bind.default)(styles('grid-cell', `span-${columns}-columns`), className);
  const composedStyles = {
    alignSelf,
    justifySelf,
    ...style
  };

  if (rows && rows > 1) {
    composedStyles.gridRow = `span ${rows}`;
  }

  if (padding) {
    composedStyles.padding = formatToCSS(padding);
  }

  return _react.default.createElement("div", {
    className: composedClassname,
    style: composedStyles,
    "data-testid": dataTestId
  }, children);
});
exports.GridCell = GridCell;
const Grid = (0, _mobxReact.observer)(({
  children,
  className,
  dataTestId,
  columns,
  rows,
  gap,
  padding,
  alignItems,
  alignContent,
  justifyContent,
  justifyItems,
  columnsMinContent,
  backgroundColor,
  style
}) => {
  let cellRows = 0;
  let cellColumns = 0;

  _react.default.Children.toArray(children).forEach(child => {
    if (_react.default.isValidElement(child) && child.type === GridCell) {
      const props = child.props;
      cellColumns += props.columns || 1;

      if (props.rows) {
        cellRows += props.rows;
      }
    } else {
      cellColumns++;
    }
  });

  const composedStyles = {
    alignItems,
    justifyItems,
    alignContent,
    justifyContent,
    backgroundColor,
    ...style
  };
  const composedClassname = (0, _bind.default)(styles('grid', `columns-${columnsMinContent && 'min-content' || columns || Math.min(cellColumns, 12)}`), className);

  if (rows || cellRows) {
    composedStyles.gridTemplateRows = `repeat(${rows || cellRows}, 1fr)`;
  }

  if (padding) {
    composedStyles.padding = formatToCSS(padding);
  }

  if (gap) {
    composedStyles.gap = formatToCSS(gap);
  }

  return _react.default.createElement("div", {
    className: composedClassname,
    style: composedStyles,
    "data-testid": dataTestId
  }, children);
});
exports.Grid = Grid;

var _default = Object.assign(Grid, {
  Cell: GridCell
});

exports.default = _default;